/* eslint-disable react-hooks/exhaustive-deps */
import { KTSVG } from '../../_metronic/helpers'
import React, { useState, useEffect } from 'react'
import { Table } from 'react-bootstrap-v5';
import Swal from 'sweetalert2'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select, { components } from 'react-select'
import AsyncSelect from 'react-select/async'
import { Link } from 'react-router-dom';
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import { useHistory } from "react-router-dom";

const ITEM_TYPE_OPTIONS = [
    { value: 'raw_material', label: 'Raw Material' },
    { value: 'finished_product', label: 'Finished Product' },
];

interface IssueRows {
    idItems: number;
    idProducts?: number;
    itemCode: string;
    unitName: string;
    stockQuantity: number;
    quantity: number;
    rate: number;
    amount: number;
    selectedOption?: any;
    [key: string]: any;
}

interface Consumption {
    idInvConsumptions: number;
    consumptionTitle: string;
}

interface OpeningData {
    idProjects: number;
    idWarehouses?: number;
    idInvConsumptions: number;
    idAccLedgers?: number;
    idUsers?: number;
    itemType: string;
    issueDate: string;
    remarks: string;
    totalAmount?: number;
}

const emptyRow = (): IssueRows => ({
    idItems: 0,
    idProducts: 0,
    itemCode: '',
    unitName: '',
    stockQuantity: 0,
    quantity: 0,
    rate: 0,
    amount: 0,
    selectedOption: null,
});

const LedgerSingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
        <>
            <div className='row'>
                <span> {props.data.label} </span>
            </div>
        </>
    </components.SingleValue>
)

const CustomOption = (props) => {
    return (
        <components.Option {...props}>
            <i className="fa fa-file"></i>
            <span> {props.data.label} </span><br />
            {props.data.ledgerPath && (
                <span><i className="fas fa-route"></i> {props.data.ledgerPath} </span>
            )}
        </components.Option>
    );
};

const InventoryStockIssueCreate = () => {
    let history = useHistory();

    const openingData: OpeningData = {
        idProjects: 0,
        idInvConsumptions: 0,
        idAccLedgers: 0,
        idUsers: 0,
        itemType: 'raw_material',
        issueDate: '',
        remarks: '',
        totalAmount: 0,
    };

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [warehouses, setWarehouses] = useState([]);
    const [warehouse, setWarehouse] = useState({ label: 'Select Warehouse', value: '' });
    const [itemType, setItemType] = useState<any>(ITEM_TYPE_OPTIONS[0]);

    const [consumption, setConsumption] = useState({ label: 'Select Consumption', value: '' });
    const [consumptions, setConsumptions] = useState<Consumption[]>([]);

    const [expenseLedger, setExpenseLedger] = useState({ label: 'Select Ledger', value: '' });
    const [expenseLedgers, setExpenseLedgers] = useState<Consumption[]>([]);

    const [user, setUser] = useState({ label: 'Select User', value: '' });
    const [users, setUsers] = useState([]);

    const [issue, setIssue] = useState(openingData);
    const [issueRows, setIssueRows] = useState<IssueRows[]>([emptyRow()]);
    const [items, setItems] = useState<any[]>([]);

    const isFinishedProduct = itemType?.value === 'finished_product';
    const nameColumnLabel = isFinishedProduct ? 'Product Name' : 'Item Name';
    const codeColumnLabel = isFinishedProduct ? 'Product Code' : 'Item Code';
    const canSearchProducts = !!(project?.value && warehouse?.value && issue.issueDate);

    useEffect(() => {
        getProjects();
        getConsumptions();
        getExpenseLedgers();
        getUsers();
    }, []);

    const getProjects = () => {
        fetch(process.env.REACT_APP_API_URL + 'lead/projects', getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getWarehousesByProject = (idProjects: number) => {
        if (!idProjects) {
            setWarehouses([]);
            setWarehouse({ label: 'Select Warehouse', value: '' });
            return;
        }
        fetch(process.env.REACT_APP_API_URL + 'warehouse/' + idProjects + '/list', getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success && Array.isArray(resp.data)) {
                    const whOptions = resp.data.map((item: any) => ({
                        label: item.name,
                        value: item.id_warehouses
                    }));
                    setWarehouses(whOptions);
                } else {
                    setWarehouses([]);
                }
                setWarehouse({ label: 'Select Warehouse', value: '' });
            })
            .catch(() => {
                setWarehouses([]);
                setWarehouse({ label: 'Select Warehouse', value: '' });
            });
    };

    const resetRows = () => setIssueRows([emptyRow()]);

    const handleWarehouseChange = (selected: any) => {
        setWarehouse(selected);
        setIssue((prev) => ({ ...prev, idWarehouses: selected ? selected.value : '' }));
        resetRows();
    };

    const handleItemTypeChange = (selected: any) => {
        setItemType(selected);
        setIssue((prev) => ({ ...prev, itemType: selected?.value || 'raw_material' }));
        resetRows();
        setItems([]);

        if (selected?.value !== 'finished_product' && project?.value) {
            getItems();
        }
    };

    const handleProjectChange = (project: any) => {
        setProject(project);
        resetRows();
        setIssue((prev) => ({ ...prev, idProjects: project.value, idWarehouses: undefined }));
        setWarehouse({ label: 'Select Warehouse', value: '' });
        getWarehousesByProject(project.value);
        setItems([]);

        if (!isFinishedProduct) {
            getItems();
        }
    };

    const handleConsumptionChange = (consumption: any) => {
        setConsumption(consumption);
        setIssue({ ...issue, idInvConsumptions: consumption.value });
    }

    const handleExpenseLedgerChange = (ledger: any) => {
        setExpenseLedger(ledger);
        setIssue({ ...issue, idAccLedgers: ledger.value });
    }

    const handleUserChange = (selectedUser: any) => {
        setUser(selectedUser);
        setIssue({ ...issue, idUsers: selectedUser.value });
    }

    const handleItemChange = async (data: any, index: number) => {
        if (!data) {
            const updatedIssueRows = [...issueRows];
            updatedIssueRows[index] = emptyRow();
            setIssueRows(updatedIssueRows);
            return;
        }

        if (issue.idProjects === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Select Project',
                text: 'Please select project first',
            })
            return;
        }

        if (isFinishedProduct) {
            if (!warehouse?.value) {
                Swal.fire({ icon: 'error', title: 'Select Warehouse', text: 'Please select warehouse first' });
                return;
            }
            if (!issue.issueDate) {
                Swal.fire({ icon: 'error', title: 'Select Issue Date', text: 'Please select issue date first' });
                return;
            }

            const updatedIssueRows = [...issueRows];
            updatedIssueRows[index].idProducts = data.idProducts || data.value;
            updatedIssueRows[index].idItems = data.idItems || 0;
            updatedIssueRows[index].itemCode = data.itemCode || '';
            updatedIssueRows[index].unitName = data.unitName || '';
            updatedIssueRows[index].stockQuantity = Number(data.stockQuantity || 0);
            updatedIssueRows[index].rate = Number(data.averageRate || 0);
            updatedIssueRows[index].quantity = 0;
            updatedIssueRows[index].amount = 0;
            updatedIssueRows[index].selectedOption = data;
            setIssueRows(updatedIssueRows);
            return;
        }

        try {
            let itemStockInfo = await getItemStock(data.value, issue.idProjects);
            const updatedIssueRows = [...issueRows];
            updatedIssueRows[index].idItems = data.value;
            updatedIssueRows[index].idProducts = 0;
            updatedIssueRows[index].itemCode = data.itemCode;
            updatedIssueRows[index].unitName = data.unitName;
            updatedIssueRows[index].stockQuantity = Number(itemStockInfo.stockQuantity);
            updatedIssueRows[index].rate = Number(itemStockInfo.avgRate);
            updatedIssueRows[index].selectedOption = data;
            setIssueRows(updatedIssueRows);
        } catch (error) {
            console.error('Error fetching item stock info:', error);
        }
    };

    const getItems = () => {
        fetch(process.env.REACT_APP_API_URL + 'production-items', getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                let items = resp.data.map((item: any) => {
                    item.label = item.itemName;
                    item.value = item.idItems;
                    return item
                })
                setItems(items);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getProducts = (
        idProjects: number | string,
        idWarehouses: number | string,
        issueDate: string,
        search = ''
    ): Promise<any[]> => {
        if (!idProjects || !idWarehouses || !issueDate) {
            return Promise.resolve([]);
        }

        const params = new URLSearchParams({
            id_projects: String(idProjects),
            id_warehouses: String(idWarehouses),
            adjustment_date: issueDate,
            search: search.trim(),
            limit: '40',
            page: '1',
        });

        return fetch(process.env.REACT_APP_API_URL + 'item-stock-adjustment/products-with-stock?' + params, getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                return (resp.status && Array.isArray(resp.data) ? resp.data : []).map((item: any) => {
                    const packingUnit = [item.packing, item.unitName].filter(Boolean).join(' ');
                    const productCode = item.productCode || item.itemCode || '';
                    const productName = item.productName || item.itemName || '';
                    const label = item.label && String(item.label).includes('Code:')
                        ? item.label
                        : (productCode
                            ? `${productName}${packingUnit ? ' (' + packingUnit + ')' : ''} Code: ${productCode}`
                            : `${productName}${packingUnit ? ' (' + packingUnit + ')' : ''}`);

                    return {
                        ...item,
                        label,
                        value: item.idProducts || item.value,
                        itemCode: productCode,
                    };
                });
            })
            .catch(() => []);
    }

    const loadProductOptions = (inputValue: string): Promise<any[]> => {
        if (!project?.value || !warehouse?.value || !issue.issueDate) {
            return Promise.resolve([]);
        }
        return getProducts(project.value, warehouse.value, issue.issueDate, inputValue || '');
    }

    const getItemStock = (idItems: number, idProjects: any) => {
        return fetch(
            process.env.REACT_APP_API_URL + 'item/stock/' + idItems + '?idProjects=' + idProjects,
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => resp.data)
            .catch((error) => {
                console.error('Error fetching item stock:', error);
                throw error;
            });
    };

    const getConsumptions = () => {
        fetch(process.env.REACT_APP_API_URL + 'get-inv-consumptions', getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                let consumptions = resp.data.map((item: any) => {
                    item.label = item.consumptionTitle;
                    item.value = item.idInvConsumptions;
                    return item
                })
                setConsumptions(consumptions);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getExpenseLedgers = () => {
        fetch(process.env.REACT_APP_API_URL + 'overhead/expense-ledgers', getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                let consumptions = resp.data.map((item: any) => {
                    item.label = item.ledgerName;
                    item.value = item.idAccLedgers;
                    return item
                })
                setExpenseLedgers(consumptions);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getUsers = (searchQuery = '') => {
        const url = searchQuery
            ? `${process.env.REACT_APP_API_URL}get_all_users?q=${encodeURIComponent(searchQuery)}`
            : `${process.env.REACT_APP_API_URL}get_all_users`;

        fetch(url, getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                let userObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setUsers(userObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedIssueRows = [...issueRows];
        updatedIssueRows[index][e.target.name] = e.target.value;

        const quantity = parseFloat(updatedIssueRows[index].quantity);
        const rate = parseFloat(updatedIssueRows[index].rate);
        updatedIssueRows[index].amount = parseFloat((quantity * rate).toFixed(2));

        setIssueRows(updatedIssueRows);
    }

    const deleteItem = (index: number) => {
        const updatedIssueRows = [...issueRows];
        if (updatedIssueRows && updatedIssueRows[index]) {
            updatedIssueRows.splice(index, 1);
            setIssueRows(updatedIssueRows);
        }
    }

    const addItem = () => {
        setIssueRows([...issueRows, emptyRow()]);
    }

    const handleInputOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        const nextIssue = { ...issue, [name]: value };
        setIssue(nextIssue);

        if (name === 'issueDate') {
            resetRows();
        }
    }

    const calculateTotalAmount = () => {
        let totalAmount = 0;
        for (const row of issueRows) {
            totalAmount += Number(row.amount) || 0;
        }
        return totalAmount;
    };

    const numberFormat = (value: any) => {
        value = parseFloat(value)
        if (typeof (value) !== 'number') {
            return value;
        }
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    const issueSave = async (event: any) => {
        event.preventDefault();

        if (!issue.itemType) {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Please select Item Type.' });
            return;
        }
        if (!warehouse?.value) {
            Swal.fire({ icon: 'error', title: 'Error', text: 'Please select Warehouse.' });
            return;
        }

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to create this Stock Issue?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Create it!',
        });
        if (confirm.value) {
            const postData = {
                issue: {
                    ...issue,
                    itemType: itemType?.value || 'raw_material',
                    idWarehouses: warehouse.value,
                    idUsers: user?.value,
                    totalAmount: calculateTotalAmount(),
                },
                issueRows: issueRows.map((row) => ({
                    idItems: isFinishedProduct ? (row.idItems || null) : row.idItems,
                    idProducts: isFinishedProduct ? row.idProducts : null,
                    rate: row.rate,
                    quantity: row.quantity,
                    stockQuantity: row.stockQuantity,
                })),
            };
            const requestOptions = postRequestOptions(postData);
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}inventory-stock-issue`,
                    requestOptions
                );
                let respData = await response.json();
                if (respData.success === true) {
                    const successMsg = respData.successMessage;
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    });
                    history.push("/stock-issue");
                } else {
                    const errorsMessage = validationErrorMsg(respData.errors || { error: [respData.errorMessage || 'Something went wrong'] }).join('<br>');
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: errorsMessage,
                    });
                }
            } catch (error) {
                console.log(error, 'catch the hoop');
            }
        }
    };

    return (
        <div className="card card-custom">
            <div className="card-header">
                <div className="card-title">
                    <KTSVG
                        path='/media/svg/icons/Home/Book-open.svg'
                        className='svg-icon-1 svg-icon-primary'
                    />
                    <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                        Stock Issue
                    </span>
                </div>
            </div>

            <div className="ml-12">
                <div className="card-body">
                    <form onSubmit={issueSave}>
                        <div className="form-group row">
                            <label htmlFor="itemType" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Item Type <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={itemType}
                                    onChange={handleItemTypeChange}
                                    options={ITEM_TYPE_OPTIONS}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Project <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={project}
                                    onChange={handleProjectChange}
                                    options={projects}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idWarehouses" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Select Warehouse <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={warehouse}
                                    onChange={handleWarehouseChange}
                                    options={warehouses}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isDisabled={warehouses.length === 0}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label htmlFor="issueDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Issue Date <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <input type='date' name="issueDate" id="issueDate" value={issue.issueDate || ''} onChange={handleInputOnChange} className="form-control form-control-sm" />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="stockType" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Consumption Type</label>
                            <div className="col-lg-5">
                                <Select
                                    value={consumption}
                                    onChange={handleConsumptionChange}
                                    options={consumptions}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label htmlFor="idProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Expense Ledger <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={expenseLedger}
                                    onChange={handleExpenseLedgerChange}
                                    options={expenseLedgers}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    components={{ SingleValue: LedgerSingleValue, Option: CustomOption }}
                                />
                            </div>
                        </div>

                        <div className="form-group row">
                            <label htmlFor="idUsers" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select User </label>
                            <div className="col-lg-5">
                                <Select
                                    value={user}
                                    onChange={handleUserChange}
                                    options={users}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isSearchable={true}
                                    onInputChange={(inputValue) => {
                                        if (inputValue.length >= 2) {
                                            getUsers(inputValue);
                                        } else if (inputValue.length === 0) {
                                            getUsers();
                                        }
                                    }}
                                    placeholder="Type to search users..."
                                />
                            </div>
                        </div>

                        <div className="form-group row mb-2">
                            <label htmlFor="remarks" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Remarks</label>
                            <div className="col-lg-5">
                                <input name="remarks" id="remarks" onChange={handleInputOnChange} className="form-control form-control-sm" />
                            </div>
                        </div>

                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2 mt-4">
                            <div className="fw-bold text-gray-800">
                                {isFinishedProduct ? 'Product Details' : 'Item Details'}
                            </div>
                            {isFinishedProduct && (!warehouse?.value || !issue.issueDate) && (
                                <div className="d-flex flex-wrap align-items-center gap-2 fs-7 text-gray-600">
                                    <span className="text-muted">To load products, complete:</span>
                                    <span className={`badge badge-light${warehouse?.value ? '-success' : ''} fw-normal`}>
                                        {warehouse?.value ? '✓ Warehouse' : 'Warehouse'}
                                    </span>
                                    <span className={`badge badge-light${issue.issueDate ? '-success' : ''} fw-normal`}>
                                        {issue.issueDate ? '✓ Issue Date' : 'Issue Date'}
                                    </span>
                                </div>
                            )}
                        </div>

                        <Table size='sm' bordered hover>
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }} className='text-center'>SL</th>
                                    <th style={{ width: '30%' }}>{nameColumnLabel}</th>
                                    <th style={{ width: '10%' }}>{codeColumnLabel}</th>
                                    <th style={{ width: '10%' }}>Stock </th>
                                    <th style={{ width: '10%' }}>Quantity</th>
                                    <th style={{ width: '10%' }}>Rate</th>
                                    <th style={{ width: '10%' }}>Amount</th>
                                    <th style={{ width: '5%' }}></th>
                                </tr>
                            </thead>

                            <tbody>
                                {issueRows.map((row, index) => (
                                    <tr key={'item-' + index}>
                                        <td className='text-center'>{index + 1}</td>
                                        <td>
                                            {isFinishedProduct ? (
                                                <AsyncSelect
                                                    key={`product-${index}-${project?.value}-${warehouse?.value}-${issue.issueDate}`}
                                                    cacheOptions={false}
                                                    defaultOptions={canSearchProducts}
                                                    loadOptions={loadProductOptions}
                                                    filterOption={null}
                                                    value={row.selectedOption || null}
                                                    onChange={(selectedOption) => handleItemChange(selectedOption, index)}
                                                    placeholder={
                                                        canSearchProducts
                                                            ? 'Search product by name or code...'
                                                            : 'Select warehouse & date first...'
                                                    }
                                                    isDisabled={!canSearchProducts}
                                                    isClearable
                                                    menuPosition="fixed"
                                                    menuPortalTarget={document.body}
                                                    className='sm'
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            minHeight: '32px',
                                                            height: '32px',
                                                        }),
                                                        valueContainer: (provided) => ({
                                                            ...provided,
                                                            height: '32px',
                                                            padding: '0 8px',
                                                        }),
                                                        indicatorsContainer: (provided) => ({
                                                            ...provided,
                                                            height: '32px',
                                                        }),
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    }}
                                                />
                                            ) : (
                                                <Select
                                                    key={`item-${index}-${itemType?.value}`}
                                                    placeholder="Search item..."
                                                    value={row.selectedOption || null}
                                                    onChange={(selectedOption) => handleItemChange(selectedOption, index)}
                                                    options={items}
                                                    isSearchable
                                                    filterOption={(option, input) => {
                                                        const q = (input || '').toLowerCase();
                                                        if (!q) return true;
                                                        const label = String(option.label || '').toLowerCase();
                                                        const code = String(option.data?.itemCode || '').toLowerCase();
                                                        return label.includes(q) || code.includes(q);
                                                    }}
                                                    className='sm'
                                                    menuPosition="fixed"
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        control: (provided) => ({
                                                            ...provided,
                                                            minHeight: '32px',
                                                            height: '32px',
                                                        }),
                                                        valueContainer: (provided) => ({
                                                            ...provided,
                                                            height: '32px',
                                                            padding: '0 8px',
                                                        }),
                                                        indicatorsContainer: (provided) => ({
                                                            ...provided,
                                                            height: '32px',
                                                        }),
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    }}
                                                />
                                            )}
                                        </td>
                                        <td>
                                            <input type="text" name="itemCode" value={row.itemCode} readOnly className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <div className='input-group input-group-sm'>
                                                <input type="text" name="stockQuantity" value={row.stockQuantity} readOnly className="form-control form-control-sm" />
                                                <span className='input-group-text'>{row.unitName}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='input-group input-group-sm'>
                                                <input type="number" name="quantity" value={row.quantity} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                                <span className='input-group-text'>{row.unitName}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <input type="number" name="rate" value={row.rate} onChange={(event) => handleChange(event, index)} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            <input type="number" name="amount" readOnly value={row.amount} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            {
                                                issueRows.length > 1 &&
                                                <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteItem(index)}>
                                                    <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                                </button>
                                            }

                                            {index === issueRows.length - 1 && (
                                                <button type='button' className="btn btn-success btn-sm px-2 py-1" onClick={addItem}>
                                                    <KTSVG path='/media/svg/icons/Navigation/Plus.svg' className='svg-icon-5 svg-icon-danger me-0' /> Add
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}

                                <tr>
                                    <td colSpan={6} className='text-end'><b>Total Amount:</b></td>
                                    <td><b>{numberFormat(calculateTotalAmount())}</b></td>
                                </tr>
                            </tbody>
                        </Table>

                        <div className="row mt-4">
                            <div className="col-12 text-center">
                                <button type="submit" className="btn btn-sm btn-primary me-2">
                                    <span>  Submit</span>
                                </button>
                                <Link to='/stock-issue' type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default InventoryStockIssueCreate
